import MembersList from "@/components/MultiAccount/MembersList";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {createFileRoute} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";
import {useTranslation} from "react-i18next";
import {useTitle} from "react-use";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/customers")({
  component: AgencyCustomers,
  params: {
    parse: raw => ({agencyId: +raw.agencyId}),
    stringify: params => ({agencyId: params.agencyId?.toString()}),
  },
  loader: () => {
    getDefaultStore().set(selectedCompanyIdAtom, null);
  },
});

function AgencyCustomers() {
  const {t} = useTranslation("navigation");

  useTitle(t("customers"));

  return (
    <div className="max-w-wide my-20 flex justify-center self-center px-5 sm:my-40">
      <MembersList />
    </div>
  );
}
